// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"d7b4467d","871":"181497fa"}[chunkId] + ".chunk.css";
};